import { ControlPosition, Map } from 'shared/map-exports';
import { CSSProperties, useState } from 'react';
import { useMapGLController } from 'features/mapping/hooks/useMapGLController/useMapGLController';
import { useMapEvent } from 'features/mapping/hooks/useMapEvent';
import {
  BaseMapboxGLController,
  BaseMapboxGLControllerProps,
} from '../BaseMapboxGLController';

type ZoomLevelControlProps = {
  position?: ControlPosition;
  style?: CSSProperties;
};

const ZoomLevelControlContent = (
  props: ZoomLevelControlProps & { map?: Map },
): JSX.Element | null => {
  const { map, style } = props;
  const [zoom, setZoom] = useState<number | undefined>(() => map?.getZoom());

  useMapEvent(
    'zoom',
    (event) => {
      setZoom(event.target.getZoom());
    },
    map,
    true,
  );

  if (!zoom) return null;

  return (
    <div className="mapboxgl-ctrl mapboxgl-ctrl-scale" style={style}>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      {zoom.toFixed(1)}z
    </div>
  );
};

class MapboxGLZoomLevelController extends BaseMapboxGLController<
  ZoomLevelControlProps & BaseMapboxGLControllerProps & { map?: Map }
> {
  content = (): JSX.Element => (
    <ZoomLevelControlContent map={this.map} {...this.props} />
  );
}

export const ZoomLevelControl = (props: ZoomLevelControlProps): null => {
  useMapGLController(props, MapboxGLZoomLevelController);
  return null;
};
